module.exports = __webpack_public_path__ + "static/assets/83f752b990fd8a9b008deb17e4f3698d.png";